let timelineElements = [
  {
    id: 1,
    title: "My first program 📅",
    location: "Home",
    description:
      "When I was 12 years old, during the summer vacations, I developed the first programs in Fortran to calculate perimeters, areas and volumes of a sphere, a cone and a cube. If I didn't, I couldn't go play with my neighbors 😒",
    buttonText: "",
    link: "",
    date: "July 2013",
    icon: "work",
  },
  {
    id: 2,
    title: "Bachelor's Degree 🎓",
    location: "Instituto Superior Técnico, University of Lisbon",
    description:
      "Here began my journey into Computer Science, I learned everything from machine code to artificial intelligence, through object-oriented programming, distributed systems, databases, computer networks, and even system modeling.",
    buttonText: "Check some of my projects",
    link: "https://github.com/KikoRSilva?tab=repositories",
    date: "September 2019 - July 2022",
    icon: "school",
  },
  {
    id: 3,
    title: "Frontend Developer 🧑🏽‍💻",
    location: "KDS Offshore",
    description:
      "First website developed for a company using HTML, CSS and Javascript (Vanilla) and website maintenance service.",
    buttonText: "View my first website",
    link: "http://kdsoffshore.pt/",
    date: "September 2020 - August 2022",
    icon: "work",
  },
  {
    id: 4,
    title: "Fullstack Developer 🧑🏽‍💻",
    location: "SET - Semana Empresarial e Tecnolõgica",
    description:
      "I joined the IT support team to develop the website for that edition and, currently, I am the IT Support Coordinator.",
    buttonText: "View our website",
    link: "https://set.tecnico.ulisboa.pt/",
    date: "September 2021 - September 2022",
    icon: "work",
  },
  {
    id: 5,
    title: "Frontend Developer 🧑🏽‍💻",
    location: "Thales",
    description:
      "For 5 months I worked in a team of frontend developers for an outsourcing project from JUNITEC to Thales.",
    buttonText: "",
    link: "",
    date: "March 2022 - July 2022",
    icon: "work",
  },
  {
    id: 6,
    title: "Intern Engineer 🧑🏽‍💻",
    location: "Indie Campers",
    description:
      "For a month and a half I had the excellent opportunity to join the Indie Campers Tech & Product team, working on the frontend, backend and maintenance of their website and platform.",
    buttonText: "View Indie Camper's website",
    link: "https://indiecampers.com/",
    date: "June 2022 - August 2022",
    icon: "work",
  },
  {
    id: 7,
    title: "Master's Degree 🎓",
    location: "Instituto Superior Técnico, University of Lisbon",
    description:
      "I am going to deepen my studies in Distributed Systems and Artificial Intelligence, since I enjoyed these subjects a lot during my degree.",
    buttonText: "",
    link: "",
    date: "September 2022 - Present",
    icon: "school",
  },
  {
    id: 8,
    title: "Project Manager 👨🏽‍💼",
    location: "SET - Semana Empresarial e Tecnolõgica",
    description:
      "I am managing the digital transition of SET, getting rid of paper, for this we are creating a web app to scan QR code, present statistical data of users' performances in Speed Interviews and publicize the event and the team. I have a team of Design, Frontend, Backend and DevOps (all are students) to implement all these transition needs.",
    buttonText: "",
    link: "",
    date: "September 2022 - Present",
    icon: "work",
  },
  {
    id: 9,
    title: "Junior Software Engineer 🧑🏽‍💻",
    location: "Indie Campers",
    description:
      "I am developing, as a team, scalable website solutions using the tech stack: NextJS (Frontend), NodeJS (Backend), MongoDB (Database), Redis (Cache), Contentful (CMS). I work under the Scrum methodology. ",
    buttonText: "",
    link: "",
    date: "October 2022 - Present",
    icon: "work",
  },
];

export default timelineElements;
